module.exports = __webpack_public_path__ + "media/images/countrysquared/cm-f03654fe4ba83f1e99effeb8610a0012.svg";